export const FaqPage = () => {
    return (
      <div className="container" style={{ minHeight: "80vh", padding: "20px" }}>
        <h1>Frequently Asked Questions</h1>
        <h3>How do you get school data?</h3>
        <p>We compile publicly available information and manually verify key details for accuracy.</p>
  
        <h3>Is this site affiliated with any school?</h3>
        <p>No. We are an independent project created to help parents make informed decisions.</p>
      </div>
    );
  }
  